module.exports = __webpack_public_path__ + "static/media/measure-arrow.b36c4fcc.svg";